export default class DeleteLocationWorkerRequest  {
	locationId: string;
	locationWorkerId: string;
}